module.exports = __webpack_public_path__ + "assets/x-481239.svg";